<template>
  <div>
    <div class="prompt">{{ `需提供的证明材料（要求为原件）：${prompt}` }}</div>
    <div class="prompt" v-if="remarks">{{ `备注：${remarks}` }}</div>
    <div
      class="upload-list"
      v-for="obj in uploadList"
      :key="obj.uid"
      @click="handleView(obj)"
    >
      <template v-if="obj.status === 'finished'">
        <img :src="obj.response">
      </template>
      <template v-else>
        <Progress
          v-if="obj.showProgress"
          :percent="obj.percentage"
          hide-info
        />
      </template>
    </div>
    <!-- :accept="`.${uploadFormat.join(',.')}`" -->
    <Upload
      ref="upload"
      :show-upload-list="false"
      :on-success="handleSuccess"
      :format="uploadFormat"
      :accept="accept"
      :max-size="uploadMaxSize"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :before-upload="handleBeforeUpload"
      multiple
      type="drag"
      :action="`${config.baseUrl}/api/Engineer/UploadFiles`"
      class="upload"
    >
      <div class="icon">
        <Icon type="ios-cloud-upload-outline" size="20"></Icon>
      </div>
    </Upload>
    <ImageView ref="imageView" title="查看图片" :list="uploadList" @on-image-remove="handleRemove" />
  </div>
</template>

<script>
import ImageView from '@components/image-view'
import { isMobile } from '@libs/util'
export default {
  name: 'upload',
  components: { ImageView },
  props: {
    prompt: {
      default: '',
      type: String
    },
    remarks: {
      default: '',
      type: String
    },
    files: {
      default: () => [],
      type: Array
    }
  },
  data () {
    return {
      uploadList: [],
      uploadMaxSize: 10 * 1024,
      uploadFormat: ['jpg', 'jpeg', 'png']
    }
  },
  computed: {
    config () {
      return window.config
    },
    accept () {
      return `.${this.uploadFormat.join(',.')}`
    }
  },
  watch: {
    uploadList: {
      handler (val) {
        this.$emit('update:files', val)
      },
      deep: true
    }
  },
  methods: {
    handleView (file) {
      const index = this.uploadList.findIndex(f => f.uid === file.uid)
      this.$refs['imageView'].open(index)
    },
    handleRemove (index) {
      this.uploadList.splice(index, 1)
    },
    handleSuccess (res, file, fileList) {
      file.response = `${config.baseUrl}${res}`
    },
    handleFormatError (file) {
      this.$Message.warning({
        content: `${file.name}的文件格式不正确，请选择${this.uploadFormat.join('、')}`,
        duration: 3,
        closable: true
      })
    },
    handleMaxSize (file) {
      this.$Message.warning({
        content: `文件${file.name}过大，不要超过${this.uploadMaxSize / 1024}M`,
        duration: 3,
        closable: true
      })
    },
    handleBeforeUpload (file) {
      const { uploadList } = this
      for (let i = 0; i < uploadList.length; i++) {
        if (uploadList[i].name === file.name) return false
      }
    }
  },
  mounted () {
    this.uploadList = this.$refs.upload.fileList;
  }
}
</script>

<style lang="scss" scoped>
.upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  margin-right: 4px;
  cursor: pointer;
  img {
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}
.upload {
  $width: 58px;
  width: $width;
  display: inline-block;
  .icon {
    width: $width;
    height: $width;
    line-height: $width;
  }
}
.prompt {
  line-height: 20px;
  color: #515a6e;
  margin: 8px 0;
}
</style>
